import { mq } from '@heathmont/moon-utils';

const media = {
  phone: mq(414), // xxsm
  phoneMedium: mq(576), // sm
  phoneLandscape: '@media (max-height: 414px) and (orientation: landscape)',
  tabletSmall: mq(768), // md
  tabletMedium: mq(992), // lg
  mobile: mq(1200, 'max-width'),
  desktopSmall: mq(1200), // xl
  desktopMedium: mq(1500), // 2xl
  desktopLarge: mq(1800), // 3xl
};

export default media;
